import { render } from 'react-dom';

import './style.scss';
import Style from './Style';
import Widget from './Widget';

// Sound Cloud
document.addEventListener('DOMContentLoaded', () => {
	const allSoundCloud = document.querySelectorAll('.wp-block-scb-sound-cloud');

	allSoundCloud.forEach(soundCloud => {
		const attributes = JSON.parse(soundCloud.dataset.attributes);

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} />
			<Widget attributes={attributes} clientId={attributes.cId} />
		</>, soundCloud);

		soundCloud?.removeAttribute('data-attributes');
	});
});